module.exports = __webpack_public_path__ + "assets/img/avatorChild.34856014.png";